<div class="wrapper">
  <adf-global-application-toolbar>
    <div left-nav class="ms-2 d-flex gap-2 align-items-center">
      <button
        *adfHasPermission="'Calculation.Read'"
        adfToolbarButton
        class="text-white"
        Icon="bi-folder2-open"
        [routerLink]="['/calculations/gotoopened']"
      >
        Opened
      </button>
      <button
        *adfHasRole="['Admin', 'System Admin']"
        adfToolbarButton
        class="text-white"
        Icon="bi-database"
        [routerLink]="['/master-data']"
      >
        Masterdata
      </button>
      <div class="border-end" style="height: 37px"></div>
      <button
        *adfHasPermission="'Calculation.Create'"
        adfToolbarButton
        class="text-white"
        Icon="bi-plus-circle"
        (click)="onNewCalculation()"
      >
        New Calculation
      </button>
      <button
        *adfHasPermission="'Calculation.Create'"
        adfToolbarButton
        class="text-white"
        Icon="bi-subtract"
        ngbTooltip="FUNCTIONALITY NOT YET IMPLEMENTED"
      >
        Consolidate Calculations
      </button>
    </div>
    <div title class="text-white">{{ title }}</div>
    <div right-nav class="d-flex align-items-center gap-2">
      <adf-zoom-control (zoomChange)="onZoomChange($event)"></adf-zoom-control>
    </div>
  </adf-global-application-toolbar>
  <!-- Full Height Content Container -->
  <main class="content h-100 w-100">
    <!--
      The routed content and the help panel are split panes so the divider between them can be dragged.
      The help pane is collapsed/expanded through the splitter API rather than removed, which keeps its
      width across open/close.
    -->
    <ejs-splitter
      #helpSplitter
      height="100%"
      width="100%"
      orientation="Horizontal"
      separatorSize="4"
      cssClass="help-splitter"
    >
      <e-panes>
        <e-pane min="400px" [collapsible]="false">
          <ng-template #content>
            <div class="main-viewport p-4 h-100 position-relative">
              @if (isNavigating$ | async) {
                <div class="route-loader-overlay">
                  <adf-route-logo-spinner size="large"></adf-route-logo-spinner>
                </div>
              }
              <router-outlet></router-outlet>
            </div>
          </ng-template>
        </e-pane>
        <e-pane size="380px" min="280px" max="50%" [collapsible]="false" [collapsed]="true">
          <ng-template #content>
            <adf-help-panel></adf-help-panel>
          </ng-template>
        </e-pane>
      </e-panes>
    </ejs-splitter>
  </main>
</div>
<adf-toast aria-live="polite" aria-atomic="true" />
<adf-background-jobs-indicator />
